import DataMasking from "@/components/dataMasking/DataMasking";
import MaskDynamicComponent from "@/components/dataMasking/MaskDynamicComponent";
import { dnbComLog, isNotUndefined } from "@/shared/FunctionCore";
import { siteSearchResultPageRoutes } from "@/app/router/routes";

export const checkSupression = (data, maskPopupData) => {
  if (data.includes("?\t")) {
    return <DataMasking />;
  } else if(data.includes("#\t")) {
    return <MaskDynamicComponent 
  buttonLabel={maskPopupData?.buttonLabel}
  text={maskPopupData?.text}
  type={maskPopupData?.type}
  buttonAction={maskPopupData.buttonAction}/> 
  } else {
    return data;
  }
};

export const getCountryAndLangaugeCodeAndDunsNumber = (url) => {
  const countryLang = url.split('/')[1]
  const counrtyCodesToCheckforLang = ['de', 'pl', 'hu'];

  let languageCode = "en";
  let countryCode = "us";
  let dunsNumber = '';

  if (isNotUndefined(countryLang.split('-'))) languageCode = countryLang.split('-')[0];

  if(languageCode === 'business')languageCode = 'en';

  if (counrtyCodesToCheckforLang.includes(languageCode)) {
    countryCode = countryLang.split('-')[1]
  }

  try {
       dunsNumber = url.split('.')[url.split('.').length-2] || '';
  } catch{

  }

  return {
    languageCode,
    countryCode,
    dunsNumber
  }
}

export const countryDictionary = {
  "de": "Germany",
  "at": "Austria",
  "ch": "Switzerland",
  "hu": "Hungary",
  "pl": "Poland"
}

export const getSiteSearchResultPagePath = (countryCode) => {
  if (countryCode === "us") {
    return {
      siteSearchResultsPathRewritten: "/site-search-results.html",
      siteSearchResultsPath: "site-search-results.html"
    }
  }

  const siteSearchResultsPathRewritten = siteSearchResultPageRoutes.find(route =>
    route.includes(`-${countryCode}`)
  )

  let siteSearchResultsPath;
  const splittedString = siteSearchResultsPathRewritten && siteSearchResultsPathRewritten.split("/")

  if (splittedString && typeof splittedString === 'object') {
    siteSearchResultsPath = splittedString[splittedString.length - 1]
  }
  
  return { siteSearchResultsPathRewritten, siteSearchResultsPath }
}

export const capitalizeWord = word => word.charAt(0).toUpperCase() + word.slice(1);

export function convertToTitleCase(str) {

  if (str.includes("-")) {
    return str
      .split('-') // Split the string by hyphens
      .map(word => capitalizeWord(word)) // Capitalize the first letter of each word
      .join(' '); // Join the words back together with spaces
  }

  return capitalizeWord(str)
}

export function areAllValuesNull(obj) {
  return Object.values(obj).every(value => value === null);
}

export const checkLinkSupression = (data) => {
  return !(data.includes("?\t") || data.includes("#\t"));
};

/**
 * Formats a date string or array into a localized date string for Excel export.
 * Handles both date arrays [year, month, day] and standard date strings.
 *
 * @param {string | number[]} dateString - The date to format, either as a string or an array.
 * @returns {string} The formatted date string (e.g., "MM/DD/YYYY") or an empty string if invalid.
 */
export const formatExcelExportDate = (dateString) => {
  try {
    let date;
    if (Array.isArray(dateString)) {
      // Array [year, month, day] and adjust month for Date object (0-indexed)
      date = new Date(dateString[0], dateString[1] - 1, dateString[2]);
    } else {
      // Parse it as a standard date string
      date = new Date(dateString);
    }

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date provided");
    }

    return date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
  } catch (error) {
    dnbComLog("Error formatting date for Excel export:", error);
    return '';
  }
};